import { create } from 'zustand'
import { User } from "../types/User"
import { doGet } from "../service/http.service";

export const useUserStore = create<{
    users: Record<string, User>
    loadUser: (userId: string) => void
    loadHistory: Record<string, boolean>
    getName: (id:string) => string|undefined
}>((set, get) => ({
    users: {},
    loadHistory: {},
    getName: (userId: string) => {
        return get().users[userId]?.username;
    },
    loadUser: (userId: string) => {
        const user = get().users[userId];
        if(user) {
            return;
        }
        set({loadHistory: {...get().loadHistory, [userId]: true}});
        doGet<User>("/users/" + userId + "/public").then((response) => {
            const users = {...get().users, [userId]: response.data};
            set({users: users});
        }).finally(() => {
            const history = {...get().loadHistory};
            delete history[userId];
            set({loadHistory: history});
        })
    }
}))
